import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalService, BsModalRef, ModalDirective, ModalOptions } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { AccessRecord } from '../model/access/access-properties/access-record';
import { AccessRight } from '../model/access/access-properties/access-right';
import { AccessUser } from '../model/access/access-properties/access-user';
import { InterfaceElement } from '../model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { InterfaceElementTypes } from '../model/interfaceElement/interfaceElement-properties/interfaceElement-type';

import { UXControllerService } from '../service/controller/ux-controller.service';
import { CosyCommunicationControllerService } from '../service/controller/cosy-communication-controller.service';

import cloneDeep  from 'lodash-es/cloneDeep';

@Component({
  selector: 'app-cosy-accessright',
  templateUrl: './cosy-accessright.component.html',
  styleUrls: ['./cosy-accessright.component.css']
})
export class CosyAccessrightComponent implements OnInit {
  @ViewChild('lgModal') public lgModal: ModalDirective;
  @ViewChild('gUsers')
  gUsers: TemplateRef<any>;
  @ViewChild('accessRightEditorTemplate')
  accessRightEditorTemplate: TemplateRef<any>;
  
  private subscriptionDE: Subscription;
  public accessModalRef: BsModalRef;
  public gUserModalRef: BsModalRef;

  public records : AccessRecord[] = [];
  public users: AccessUser[] = [];
  public globalUsers: AccessUser[] = [];
  public selectedUsers: AccessUser[] = [];
  public rights: AccessRight[]=[];

  public right1 = new AccessRight();
  public right2 = new AccessRight();
  public right3 = new AccessRight();

  
  public activeRecord: AccessRecord = new AccessRecord();
  public activeAssignedUser : AccessUser = new AccessUser();

  public finalRecordsList: AccessRecord[] = [];

  config: ModalOptions = { class: 'modal-sm' };

  constructor(private uxControllerService: UXControllerService,
    private cosyCommunicationControllerService: CosyCommunicationControllerService,
    private modalService: BsModalService) { }

  ngOnInit() {
   
    this.subscriptionDE = this.uxControllerService.showAccessRightEditor.subscribe(
      (data) => {
        data.template = this.accessRightEditorTemplate;
        this.openAccessRightEditor(data.ie, this.accessRightEditorTemplate); 
      }
    );
  }

  ngOnDestroy() {
    if (this.subscriptionDE != null) 
    {  
      this.subscriptionDE.unsubscribe(); 
    }
  }


  pickUser(user: AccessUser, checked){

    if(checked){
      let copiedUser = cloneDeep(user);
      for(let r of copiedUser.AccessRights){
        r.IsAllowed = false;
      }
      
      this.selectedUsers.push(copiedUser);
    }
    else if(!checked){
      let ui = this.selectedUsers.map(function(e){return e.ID}).indexOf(user.ID);
      if(ui > -1){
        this.selectedUsers.splice(ui,1);
      }
    }
  }

  updateRecordUserList(){
    this.users = this.users.concat(this.selectedUsers);
    this.activeRecord.AccessUsers = this.activeRecord.AccessUsers.concat(this.selectedUsers);
  }

  updateControl(controlReference, checked){
    let localUserList : AccessUser[];
    let localUser : AccessUser = new AccessUser();
    if(controlReference instanceof AccessUser){
      this.activeAssignedUser = controlReference;
    }
    else if(controlReference instanceof AccessRight){
      localUserList = cloneDeep(this.activeRecord.AccessUsers);
      localUser = cloneDeep(this.activeAssignedUser);
      
      let rightIndex = this.activeAssignedUser.AccessRights.map(function(e){return e.ID}).indexOf(controlReference.ID);
      this.activeAssignedUser.AccessRights[rightIndex].IsAllowed = checked;
      for(let lu of localUserList){
       let iu = this.activeRecord.AccessUsers.map(function(e){return e.ID}).indexOf(lu.ID);
       if(lu.ID !== this.activeAssignedUser.ID){
         this.activeRecord.AccessUsers[iu] = lu;
       }
      }
    }
  }

  switchChannel(user:AccessUser) {
    
    for(let u of this.users){
      if(u.ID == user.ID){
        this.activeAssignedUser = u;
        document.getElementById('rights-list').removeAttribute('disabled');
        document.getElementById('i-'+u.ID).classList.add('selected');  
      }else {
        document.getElementById('i-'+u.ID).classList.remove('selected'); 
      }
    }  
  }

 

  initializePermissions(){
    this.rights = [];
    this.users=[];
   
    this.right1.ID="r1";
    this.right1.Name="ReadOnly";
    this.right1.IsAllowed = false;

    this.right2.ID="r2";
    this.right2.Name="Write";
    this.right2.IsAllowed = false;

    this.right3.ID="r3";
    this.right3.Name="Full Control";
    this.right3.IsAllowed = false;

    this.rights.push(this.right1);
    this.rights.push(this.right2);
    this.rights.push(this.right3);
  

     /*Users or Groups*/
     let user1= new AccessUser();
     let user2= new AccessUser();
     let user3= new AccessUser();

     let user4= new AccessUser();
     let user5= new AccessUser();
 
     user1.ID = "u1";
     user1.Name = "Administrator";
     user1.Type = "User";
     user1.IsAllowed = false;
     user1.AccessRights.push(this.right1);
     user1.AccessRights.push(this.right2);
     user1.AccessRights.push(this.right3);
    
     user2.ID = "u2";
     user2.Name = "User";
     user2.Type = "User";
     user2.IsAllowed = false;
     user2.AccessRights.push(this.right1);
     user2.AccessRights.push(this.right2);
     user2.AccessRights.push(this.right3);
     
     user3.ID = "g1";
     user3.Name = "Group1";
     user3.Type = "Group";
     user3.IsAllowed = false;
     user3.AccessRights.push(this.right1);
     user3.AccessRights.push(this.right2);
     user3.AccessRights.push(this.right3);

     user4.ID = "u3";
     user4.Name = "User2";
     user4.Type = "User";
     user4.IsAllowed = false;
     user4.AccessRights.push(this.right1);
     user4.AccessRights.push(this.right2);
     user4.AccessRights.push(this.right3);


     user5.ID = "u4";
     user5.Name = "User4";
     user5.Type = "User";
     user5.IsAllowed = false;
     user5.AccessRights.push(this.right1);
     user5.AccessRights.push(this.right2);
     user5.AccessRights.push(this.right3);
     
     this.users.push(user1);
     this.users.push(user2);
     this.users.push(user3);

     this.globalUsers.push(user1);
     this.globalUsers.push(user2);
     this.globalUsers.push(user3);
     this.globalUsers.push(user4);
     this.globalUsers.push(user5);  
  }


  openAccessRightEditor(ie: InterfaceElement, template: TemplateRef<any>) {
    
    this.records = [];
    this.finalRecordsList = [];
    this.globalUsers = [];
    this.activeAssignedUser = null;
    
    this.activeRecord = new AccessRecord();
    this.initializePermissions();
  
    if(ie.TypeDID == InterfaceElementTypes.EntityList){
      if(ie.Values!= null && ie.Values.length>0){
        for(let v of ie.Values){
          if(v.Value!== ""){
            let rowIndex = ie.EntityList.RowItems.map(function(e){return e.ID}).indexOf(v.Value);
            if(rowIndex>-1) {
              let record = new AccessRecord();
              record.ID = ie.EntityList.RowItems[rowIndex].ID;
              record.Name = ie.EntityList.RowItems[rowIndex].DisplayName;
              record.IsAccessAllowed = false;
              record.IsAccessRestricted = false;
              record.IsAccessRevoked = false;
              record.AccessUsers= this.users;
              this.activeRecord = record;
              this.records.push(record);
            }
          }          
        }
      }
    }
    this.accessModalRef = this.modalService.show(template);
  }

  addUsers(){
   
    /*this.config = {
      animated: true,
      keyboard: true,
      backdrop: true,
      focus:true,
      ignoreBackdropClick: true,
      class: "my-modal"
    };*/
    this.selectedUsers = [];
    for(let gu of this.globalUsers){
      for(let lu of this.activeRecord.AccessUsers){
        if(lu.ID == gu.ID ){
          let mediatorUser = cloneDeep(lu);
          gu.IsAllowed = true;
          lu = mediatorUser;
        }
      }
    }
    
    this.config = { 
      backdrop: true,
      ignoreBackdropClick: true,
      class: "modal-sm accessUser-modal"
    }
    this.gUserModalRef = this.modalService.show(this.gUsers,this.config);
    this.cosyCommunicationControllerService.getAccessPermission();
  }

}


